import { useState, useEffect } from 'react';
import { connect } from "react-redux";
import { error as logError } from "../../logger";
import { UPLOAD_STATUS_WAITING_UPLOAD, uploadLocalFile, process } from "../../actions/file";

function UploadProcess({ dispatch, file, subscription }) {

    const [nextFile, setNextFile] = useState(null);
    const [lock, setLock] = useState(false);

    useEffect(() => {

        async function handleUpdates() {
            if (lock) return;
            setLock(true);

            try {
                file.files.forEach(file => {
                    if (!nextFile && file.uploadStatus === UPLOAD_STATUS_WAITING_UPLOAD) setNextFile(file);
                })

                if (nextFile) {
                    const file = nextFile;
                    setNextFile(null);
                    await dispatch(uploadLocalFile(file.id));
                } else if (subscription.subscribed) {
                    await dispatch(process());
                }
                setLock(false);
            } catch (error) {
                logError(error);
                setLock(false);
            }
        }

        handleUpdates();
    }, [subscription, file, dispatch, nextFile, setNextFile, lock, setLock])

    return null;
}

const mapStateToProps = state => ({ file: state.file, subscription: state.user.subscription })

const mapDispatchToProps = dispatch => ({ dispatch })

export default connect(mapStateToProps, mapDispatchToProps)(UploadProcess);